/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setCardCustomization} from '../api'

export const useMutationSetCardCustomization = createReactQueryMutationHook('setCardCustomization', setCardCustomization)
